import Link from 'next/link'
import { Facebook, Instagram, Mail, Phone } from 'lucide-react'
import { Hotel } from '@/payload-types'
import hotelTitle from '@/lib/helpers/hotelName'
import IconBadge from './IconBadge'

const ContactInfo = ({ hotel }: { hotel: Hotel }) => {
  return (
    <div className='space-y-6'>
      <h3 className='text-xl'>{hotelTitle(hotel.title, hotel.hotelType)}</h3>

      {hotel.phone && (
        <Link
          href={`tel:${hotel.phone}`}
          className='block w-fit transition-opacity hover:opacity-50'
        >
          <div className='flex items-center space-x-2'>
            <IconBadge icon={Phone} />
            <p className='font-medium underline'>{hotel.phone}</p>
          </div>
        </Link>
      )}

      {hotel.mail && (
        <Link
          href={`mailto:${hotel.mail}`}
          className='block w-fit transition-opacity hover:opacity-50'
        >
          <div className='flex items-center space-x-2'>
            <IconBadge icon={Mail} />
            <p className='font-medium underline'>{hotel.mail}</p>
          </div>
        </Link>
      )}

      {(hotel.instagramUrl || hotel.facebookUrl) && (
        <div className='flex flex-wrap gap-4 md:gap-8'>
          {hotel.instagramUrl && (
            <Link
              href={hotel.instagramUrl}
              className='block w-fit transition-opacity hover:opacity-50'
            >
              <div className='flex items-center space-x-2'>
                <IconBadge icon={Instagram} />
                <p className='font-medium underline'>Instagram</p>
              </div>
            </Link>
          )}

          {hotel.facebookUrl && (
            <Link
              href={hotel.facebookUrl}
              className='block w-fit transition-opacity hover:opacity-50'
            >
              <div className='flex items-center space-x-2'>
                <IconBadge icon={Facebook} />
                <p className='font-medium underline'>Facebook</p>
              </div>
            </Link>
          )}
        </div>
      )}
    </div>
  )
}

export default ContactInfo
